import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
	template: require("./template.html"),
	components: {}
})
class SelectInputTextComponent extends Vue {
	@Prop()
	source: any[]

	@Prop()
	displayField: string

	@Prop()
	valueField: string

	@Prop({default:null, type:[Object, String, Number]})
	selectedValue: any

	@Prop({ required: false })
	selectedText: string;

	@Prop({ required: false, default: "" })
	placeholder: String

	@Prop({ required: false, default: false })
	clearable: boolean

	get value(): any {
		let self = this as any;
		if (this.selectedText)
			return this.selectedText || null;
		else if(this.selectedValue == 0){
			let selectedItem = this.source && this.source.length > 0 ? this.source.find(c => c[this.valueField] == this.selectedValue) : undefined;
			return self.$td(selectedItem);
		}
		return this.selectedValue || null;
	}
	set value(value) {
		let selectedItem =this.source && this.source.length > 0 ? this.source.find(c => c[this.valueField] == value) : undefined;
		if (selectedItem) {
			this.$emit('update:selectedValue', value);
			this.$emit('update:selectedText', null);
		} else {
			this.$emit('update:selectedText', value);
			this.$emit('update:selectedValue', null);
		}
	}

	/**  constructor */
	constructor() {
		super();
	}

	created() {
	}

	handleChange() {
    }
    handleBlur(event) { 
        this.$emit('blur', event);
    }

	clear(event) {
		this.$emit('blur', null);
		this.$emit('update:selectedText', null);
		this.$emit('update:selectedValue', null);
	}
}

export default SelectInputTextComponent;
